import React from 'react';
import FormField from '../controls/FormField';
import FormSelect from '../controls/FormSelect';
import FormTextArea from '../controls/FormTextArea';
import { FIELD_TYPES } from './formFieldTypes';

/**
 * Maps one field config object to the appropriate shared form control.
 */
export default function FormFieldRenderer({
  field,
  values = {},
  errors = {},
  onFieldChange,
  disabled = false,
  renderField,
}) {
  const {
    name,
    label,
    type = FIELD_TYPES.TEXT,
    required,
    placeholder,
    options,
    helperText,
    hint,
    inputProps,
    minRows,
    disabled: fieldDisabled,
    grid: _grid,
    visible: _visible,
    id: _id,
    ...rest
  } = field;

  const value = values[name] ?? '';
  const errorMessage = errors[name];
  const isDisabled = disabled || fieldDisabled;
  const ctx = { values, errors, onFieldChange, disabled: isDisabled };

  const commonProps = {
    name,
    label,
    required,
    hint,
    placeholder,
    value,
    disabled: isDisabled,
    error: Boolean(errorMessage),
    helperText: errorMessage || helperText,
    onChange: (event) => onFieldChange?.(name, event.target.value),
    ...rest,
  };

  switch (type) {
    case FIELD_TYPES.NUMBER:
      return <FormField {...commonProps} type="number" inputProps={inputProps} />;
    case FIELD_TYPES.EMAIL:
      return <FormField {...commonProps} type="email" inputProps={inputProps} />;
    case FIELD_TYPES.TEXTAREA:
      return <FormTextArea {...commonProps} minRows={minRows} />;
    case FIELD_TYPES.SELECT:
      return <FormSelect {...commonProps} options={options} />;
    case FIELD_TYPES.CUSTOM:
      return renderField?.(field, ctx) ?? null;
    case FIELD_TYPES.TEXT:
    default:
      return <FormField {...commonProps} type="text" inputProps={inputProps} />;
  }
}
